import { loadableReady } from '@loadable/component';
import { ThemeProvider } from '@material-ui/styles';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import { createBrowserHistory } from 'history';
import queryString from 'query-string';
import React from 'react';
import deepForceUpdate from 'react-deep-force-update';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './core/components/App';
import theme from './core/themes';
import util from './core/utils';
import AppRouter from './routes';
import { MIRRORING_PAGENAME } from './routes/mirroring/constant';
import configureStore from './store/configureStore';

const initState = window.App.state;
const stateFromLs = util.ls.get(util.ls.LS_KEYS.TP_REDUX_STATE_TREE);
initState.mirroring = {
  checkin: stateFromLs?.mirroring?.checkin ?? initState.mirroring.checkin,
  classroom: stateFromLs?.mirroring?.classroom ?? initState.mirroring.classroom,
  exercise: stateFromLs?.mirroring?.exercise ?? initState.mirroring.exercise,
  questionnaire:
    stateFromLs?.mirroring?.questionnaire ?? initState.mirroring.questionnaire,
  statistics:
    stateFromLs?.mirroring?.statistics ?? initState.mirroring.statistics,
  post: stateFromLs?.mirroring?.post ?? initState.mirroring.post,
  ws: {
    isConnected: false,
    pageName: stateFromLs?.mirroring?.ws?.pageName ?? MIRRORING_PAGENAME.LOGIN,
    roomId: null,
    socketData: stateFromLs?.mirroring?.ws?.socketData ?? {},
  },
};

const hsitory = createBrowserHistory();
// Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html
const context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: (...styles) => {
    // eslint-disable-next-line no-underscore-dangle
    const removeCss = styles.map(style => style._insertCss());
    return () => removeCss.forEach(dispose => dispose());
  },
  // Initialize a new Redux store
  // http://redux.js.org/docs/basics/UsageWithReact.html
  store: configureStore(initState, { doc: document, g: window }),
  storeSubscription: null,
  g: window,
};

if (localStorage.getItem('__DEV__')) {
  window.storeDev = context.store;
}

const container = document.getElementById('app');

context.pathname = window.location.pathname;
context.query = queryString.parse(window.location.search);

let appInstance;
const render = __DEV__ ? ReactDOM.hydrate : ReactDOM.render;
loadableReady(() => {
  render(
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <ConfigProvider locale={zhCN}>
          <App hsitory={hsitory} context={context}>
            <AppRouter />
          </App>
        </ConfigProvider>
      </ThemeProvider>
    </BrowserRouter>,
    container,
  );
});

// Enable Hot Module Replacement (HMR)
if (module.hot) {
  module.hot.accept(true, () => {
    if (appInstance && appInstance.updater.isMounted(appInstance)) {
      // Force-update the whole tree, including components that refuse to update
      deepForceUpdate(appInstance);
    }
  });
}
